<app-de-wrapper>
  <ng-container *ngIf="isType('PAY_IN_ADVANCE')">
    <app-pia-success></app-pia-success>
  </ng-container>

  <div class="page-body" *ngIf="!isType('PAY_IN_ADVANCE') && loading">
    <app-spinner></app-spinner>
  </div>

  <ng-container *ngIf="!isType('PAY_IN_ADVANCE') && !loading">
    <div class="img-wrapper">
      <app-zaver-icon [size]="88" name="diamond"></app-zaver-icon>
    </div>
    <h1 class="heading">{{ successTitle }}</h1>

    <div class="text">
      {{ successPageText }}
    </div>

    <div class="info-wrapper" *ngIf="isInstantDebitPayment || isA2APayment">
      <hr class="details-divider" />
      <div class="details-container">
        <div class="details-key-entry">Totalbelopp</div>
        <div class="details-value-entry details">
          {{ state.totalCheckoutValue | value }}
        </div>
      </div>

      <hr class="details-divider" />

      <div class="details-container">
        <div class="details-key-entry">Betalsätt</div>
        <div class="details-value-entry">Betala Nu</div>
      </div>

      <hr class="details-divider" />
    </div>

    <p *ngIf="noResponseMessage" class="no-response-message">
      {{ noResponseMessage }}
    </p>

    <zaver-button-link
      *ngIf="successUrl"
      class="merchant-return-link"
      (click)="onRouteToSuccessUrl()"
      [text]="'Tillbaka till ' + state.checkoutCustomizations.merchantName"
    ></zaver-button-link>

    <div *ngIf="showAppLinks()" class="buttons-container">
      <div class="app-button" (click)="openTab(APP_STORE_LINK)">
        <app-zaver-icon
          class="apple-logo"
          override="dark"
          [size]="16"
          name="appleLogo"
        ></app-zaver-icon>
        App Store
      </div>

      <div class="app-button" (click)="openTab(PLAY_STORE_LINK)">
        <app-zaver-icon
          class="google-logo"
          override="dark"
          [size]="16"
          name="googleStore"
        ></app-zaver-icon>
        Google Play
      </div>
    </div>
  </ng-container>
</app-de-wrapper>

<zaver-checkout-modal
  *ngIf="selectorItems && modalActive"
  [buttonText]="'Stäng'"
  [title]="'Visa detaljer'"
  (onClose)="toggleModal()"
>
  <app-selector #selector [selectorItems]="selectorItems"></app-selector>
</zaver-checkout-modal>
